import { 
  createBrowserRouter,
  RouterProvider,
  Outlet
} from "react-router-dom";
import { useDispatch } from "react-redux";

// screens
// import DummyPage1 from "../screens/dummy/page1";
import DummyPage1 from './dummy/page1';
import DummyPage2 from "./dummy/page2";
import App from './app';

// dashboard
import { ScreenDashboard } from "./dashboard";

// jobs
import { ScreenJobHome } from "./jobs/home";
import { ScreenJobDetails } from "./jobs/details";
import { ScreenJobDetailsPaymentDetails } from "./jobs/payment.details";
import { ScreenJobDetailsPartner } from "./jobs/details.partner";
import { ScreenJobDetailsReports } from "./jobs/details.reports";

// new partners
import { ScreenNewPartners } from './new.partners';

// partneers
import { ScreenPartnerDetails } from "./partners/details";
import { ScreenPartnerDetailsRegistration } from "./partners/registration";

// errors
import Error401 from "./errors/401";

// providers

// reducers

export const AppRouters = () => {

  // hooks
  const dispatch = useDispatch();

  // const loadAccountProjects = async () => {
  //   if (!loaded) return null;
  //   try {
  //     dispatch(mutateFetchedProjects({
  //       projects: projects
  //     }));
  //     return {
  //       account: account,
  //       projects: projects,
  //     }
  //   } catch (err) {
  //     console.error('navigation.index@loadAccountProjects', err);
  //   }
  // }

  const router = createBrowserRouter([
    {
      path: '/',
      element: <App />,
      // loader: loadAccountProjects,
      children: [
        {
          path: 'dashboard',
          element: <ScreenDashboard />,
        },
        
        {
          path: 'jobs',
          element: <ScreenJobHome />,
          // children: [
          //   {
          //     path: 'details',
          //     element: <ScreenJobDetails />,
          //     children: [
          //       {
          //         path: 'paymentdetails',
          //         element: <ScreenJobDetailsPaymentDetails />,
          //       },
          //       {
          //         path: 'partner',
          //         element: <ScreenJobDetailsPartner />,
          //       },
          //       {
          //         path: 'reports',
          //         element: <ScreenJobDetailsReports />,
          //       }
                
          //     ]
          //   }
          // ]
        },
        {
          path: 'jobs/details',
          element: <ScreenJobDetails />,
          children: [
            {
              path: 'paymentdetails',
              element: <ScreenJobDetailsPaymentDetails />,
            },
            {
              path: 'partner',
              element: <ScreenJobDetailsPartner />,
            },
            {
              path: 'reports',
              element: <ScreenJobDetailsReports />,
            }
            
          ]
        },
        {
          path: 'team',
          element: <DummyPage2 />,
        },
        {
          path: 'partners',
          element: <Outlet />,
          children: [
            {
              path: 'registration',
              element: <ScreenNewPartners />,
            },
            {
              path: 'details/:account_id',
              element: <ScreenPartnerDetails />,
              children: [
                {
                  path: 'registration',
                  element: <ScreenPartnerDetailsRegistration />,
                }
              ]
            }
          ]
        },
        {
          path: 'error401',
          element: <Error401 />,
        },
      ]
    }
  ]);

  return (
    <RouterProvider router={router} />
  );
}